import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {ImageBuiltInControl} from '../ImageBuiltInControl';

export abstract class ImageAlignmentBuiltInControl extends ImageBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_IMAGE].ALIGNMENT;
  }
}